import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import Image from '../../../../refresh/atoms/ImageView';
import RupeeSymbol from '../../../../refresh/atoms/RupeeSymbol';
import styles from './index.pcss';
import { getmaskedPrice, getFormattedPrice } from '../../../../utils/pdp';
import {
  getPageTypesBasedFlag,
  getDeviceBasedFlag
} from '../../PriceRevealPLPBanner/priceRevealUtil';
import Text from '../../../../refresh/atoms/Text';
import { checkEarlyAccessUser } from '../../Cookie';
import { signInCheck } from '../../CheckUserStatus';
import { getEarlyAccessFlag } from '../../../../Flags/selectors';

interface PriceRevealProps {
  priceReveal: {
    bestPrice: number;
    description: string;
    discountPercent: number;
  };
  isPriceReveal: boolean;
  orignalPrice: string;
  flags: {
    priceRevealFlag: string;
  };
  deviceType: string;
  futureBestPrice: number;
  store: string;
  priceRevealClass: string;
  isPriceRevealPDP: boolean;
  offerValue: string;
  luxe: boolean;
  pageType: string;
  hasLineBreak?: boolean;
  isShopThelook?: boolean;
  earlyAccessFlag?: boolean;
  isFromAjiogramLandingPage: boolean;
}

interface StateProps {
  productsAdditionalInfo: {
    isPriceReveal: boolean;
  };
  flags: {
    priceRevealFlag: string;
  };
  metaData: {
    name: string;
  };
}

interface StateReturn {
  isPriceReveal: boolean;
  flags: {
    priceRevealFlag: string;
  };
  store: string;
  earlyAccessFlag: boolean;
}

const cx = classNames.bind(styles);

const mapStateToProps = (state: StateProps, ownProps: PriceRevealProps): StateReturn => ({
  isPriceReveal: state.productsAdditionalInfo.isPriceReveal || ownProps.isPriceReveal,
  flags: state.flags,
  store: state.metaData.name || 'AJIO',
  earlyAccessFlag: getEarlyAccessFlag(state.flags)
});

const connector = connect(mapStateToProps, null);

const attachRupeeSymbol = (
  price: Element | string,
  luxe: boolean,
  deviceType: string
): ReactElement => {
  return (
    <>
      {luxe ? (
        <span
          style={{ fontWeight: 'normal' }}
          className={deviceType == 'desktop' ? cx('rupeesSymbol') : ''}
        >
          &#8377;
        </span>
      ) : (
        <RupeeSymbol />
      )}
      {price}
    </>
  );
};

const PriceRevealPLP = (props: PriceRevealProps): ReactElement | null => {
  const {
    priceReveal = {},
    isPriceReveal = false,
    orignalPrice,
    flags = {},
    deviceType = 'msite',
    futureBestPrice = '',
    store,
    isPriceRevealPDP = false,
    priceRevealClass = '',
    offerValue = '',
    luxe,
    pageType,
    isPlpOnLandingWidget,
    isWishlistHalfcard,
    hasLineBreak = false,
    isShopThelook,
    earlyAccessFlag,
    isFromAjiogramLandingPage = false
  } = props;

  const priceRevealState = getPageTypesBasedFlag(deviceType, flags, store);

  const isSignedIn = signInCheck();
  const isEarlyAccessUser = !!(
    !luxe &&
    isSignedIn &&
    earlyAccessFlag &&
    checkEarlyAccessUser(store, 'plp') &&
    priceRevealState != 'DURING_SALE'
  );
  const { pathname = '' } = window?.location || {};
  let { bestPrice, discountPercent = 0 } = priceReveal;

  if (pathname?.includes('/wishlist') && !isEarlyAccessUser) {
    bestPrice = futureBestPrice;
  }

  if (!bestPrice && offerValue) {
    bestPrice = offerValue;
  }
  const {
    bbsPriceStaticText,
    priceImgSrc,
    luxebbsPriceStaticText,
    luxePriceImgSrc,
    priceComingSoonTxt,
    luxePriceComingSoonTxt
  } = getDeviceBasedFlag(deviceType, flags) as {
    bbsPriceStaticText: string;
    luxebbsPriceStaticText: string;
    priceImgSrc: any;
    luxePriceImgSrc: any;
    priceComingSoonTxt: string;
    luxePriceComingSoonTxt: string;
  };

  const GetPrice = ({ bestPrice }: { bestPrice: number }): ReactElement | null => {
    if (bestPrice) {
      if (bestPrice === -1) {
        return isPriceRevealPDP || isPriceReveal ? (
          luxe ? (
            <div className={cx('luxePriceRevealSoon')} aria-label={luxePriceComingSoonTxt}>{luxePriceComingSoonTxt}</div>
          ) : (
            <div aria-label={priceComingSoonTxt}>{priceComingSoonTxt}</div>
          )
        ) : (
          <div className={luxe ? cx('luxeBBSStaticText') : undefined} aria-label={luxe?luxebbsPriceStaticText:bbsPriceStaticText}>
            {luxe ? luxebbsPriceStaticText : bbsPriceStaticText} {hasLineBreak && <br />}
            <span className={luxe ? cx('luxeBBSPrice') : undefined}>
              {isEarlyAccessUser & !luxe
                ? attachRupeeSymbol(parseInt(orignalPrice, 10), luxe, deviceType)
                : attachRupeeSymbol(getmaskedPrice(parseInt(orignalPrice, 10)), luxe, deviceType)}
            </span>
            {luxe && (isPriceReveal || isPriceRevealPDP) && discountPercent > 0 ? (
              <div className={cx('discount', 'discountpad')}>
                <Text variant="T1" weight="bold" color={luxe ? 'Light_Black' : 'Jade'}>
                  {`${discountPercent}% OFF`}
                </Text>
              </div>
            ) : null}
          </div>
        );
      }
      return (
        <div className={luxe ? cx('luxeBBSStaticText') : undefined}>
          {luxe ? luxebbsPriceStaticText : bbsPriceStaticText} {hasLineBreak && <br />}
          <span className={luxe ? cx('luxeBBSPrice') : undefined}>
            {isEarlyAccessUser && !luxe
              ? attachRupeeSymbol(bestPrice, luxe, deviceType)
              : attachRupeeSymbol(
                  isPriceRevealPDP || isPriceReveal
                    ? luxe
                      ? getFormattedPrice(parseInt(bestPrice, 10))
                      : bestPrice
                    : getmaskedPrice(parseInt(orignalPrice, 10)),
                  luxe,
                  deviceType
                )}
            {luxe && (isPriceReveal || isPriceRevealPDP) && discountPercent ? (
              <div className={cx('discount', 'discountpad')}>
                <Text variant="T1" weight="bold" color={luxe ? 'Light_Black' : 'Jade'}>
                  {`${discountPercent}% OFF`}
                </Text>
              </div>
            ) : null}
          </span>
        </div>
      );
    }
    return null;
  };
  if (!bestPrice || !priceRevealState) return <div />;
  const containerClass = isShopThelook ? 'shopTheLookPriceReveal' : 'priceRevealPLP';
  return (
    <div
      className={cx(
        containerClass,
        priceRevealClass,
        deviceType,
        luxe && pageType === 'pdp'
          ? 'luxePriceRevealPLPPdp'
          : luxe && pageType === 'landing screen'
          ? 'luxePriceRevealLanding'
          : luxe
          ? 'luxePriceRevealPLP'
          : '',
        luxe && isWishlistHalfcard ? 'luxehalfCardMargin' : '',
        luxe && isPlpOnLandingWidget ? 'luxePlpOnLanding' : '',
        isEarlyAccessUser && !luxe && 'earlyAccessBackground',
        isFromAjiogramLandingPage ? 'ajiogram' : ''
      )}
    >
      <Image 
        src={luxe ? luxePriceImgSrc?.image : priceImgSrc?.image} 
        // alt={luxe ? luxePriceImgSrc?.altText : priceImgSrc?.altText ||"price-reveal"} 
        alt='sale'
        ariaHidden={true}
      />
      <span className={luxe ? cx('luxe-getPrice') : undefined}>
        <strong><GetPrice bestPrice={bestPrice} /></strong>
      </span>
    </div>
  );
};

export default connector(PriceRevealPLP);
